import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { isLocalParticipantModerator } from '../../../base/participants';
import { toggleHangUpSettings } from '../../../settings';
import HangupButton from '../HangupButton';

import HangUpSettingsPopup from './HangUpSettingsPopup';

declare var interfaceConfig: object;


/**
 * HangupSettings.
 */
function HangupSettings({ customClass, visible }) {
    const dispatch = useDispatch();
    const onVideoOptionsClick = () => dispatch(toggleHangUpSettings());
    const isModerator = useSelector(state => isLocalParticipantModerator(state));
    const { t } = useTranslation();
    const { interfaceConfig: intConfig } = useSelector(state => state['features/base/config']);
    const partipicipantss = useSelector(state => state['features/base/participants']);
    const isRemoteParticipants = partipicipantss.filter(it => it.local !== true) ?? [];
    const hangupOption = intConfig.hangupOptions ?? interfaceConfig?.hangupOptions;

    // const hangupBtn = document.getElementsByClassName('hangup-button');
    // const hangupText = document.createElement('span');
    // hangupText.innerHTML = t('toolbar.hangUp');
    // hangupBtn[0].appendChild(hangupText);

    return (
        <HangUpSettingsPopup>
            <HangupButton
                customClass = { customClass }
                label = { t('toolbar.hangup') }
                onClickWeb = { isModerator && isRemoteParticipants.length > 0 && hangupOption
                    ? onVideoOptionsClick : false }
                visible = { visible } />
        </HangUpSettingsPopup>
    );
}

export default HangupSettings;
